import { Component, OnInit, ElementRef, OnDestroy, ViewChild  } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CatalogoService } from 'src/app/aplicaciones-modulos/distribuidores/services/catalogo.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';

import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';


@Component({
  selector: 'app-upload-presupuesto-promocional',
  templateUrl: './upload-presupuesto-promocional.component.html',
  styleUrls: ['./upload-presupuesto-promocional.component.css']
})
export class UploadPresupuestoPromocionalComponent implements OnInit {

  titulo = 'Carga de Presupuesto Promocional';
  mostrarFormulario = false;

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading : boolean = false;
  loading2: boolean = false;
  listaVacia: boolean = true;

  modulo: any = indicadoresVivosModulo;

  DAT_BTNS  = this.modulo.button.buttonsNombre;
  DAT_MSG   = this.modulo.mensajes;
  DAT_BTNCSS = this.modulo.button.buttonsCss;

  modelGrid: any;
  csv: string;
  objSelected: any = {};
  listaVaciaCli: boolean = true;
  errorData: boolean = true;

  cmbxMeses : any = [];
  usuario: string;

  constructor(
        public fb: FormBuilder,
        private _util: UtilsService,
        private catalogo: CatalogoService,
        private catalogoPresupuesto: CatalogoIndicadoresService,
        private _indicadores: IndicadoresVivosService,
        private _dmaestrosServices : DatosMaestrosService,
  ) { }

  ngOnInit(): void {

    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.usuario = userData.login2;

    this.cmbxMeses  = this.catalogoPresupuesto.catalogoMeses();
    const year = new Date().getFullYear();

    this.formulario = this.fb.group({
      anio      : [year, [Validators.required, 
                          Validators.pattern(/[0-9]+/), 
                          Validators.maxLength(4), 
                          Validators.minLength(4),
                          Validators.min(2000),
                          Validators.max(2100)]],
      multipart : ['', [Validators.required]],
    });

    this.cargarGrid();

  }

  /** FUNCIONES */
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      { headerName: 'ESTADO', sortable: true, filter: true, width: 150,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) { return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO'; }
      },
      { field: 'anio',                sortable: true, filter: true, resizable: true },
      { field: 'idOrganizacionVenta', sortable: true, filter: true, resizable: true },
      { field: 'organizacionVentaDsca', sortable: true, filter: true, resizable: true },
      { field: 'idCanalVenta',    sortable: true, filter: true, resizable: true },
      { field: 'canalVentaDsca',  sortable: true, filter: true, resizable: true },
      { field: 'idUnidadNegocio', sortable: true, filter: true, resizable: true },
      { field: 'unidadNegocioDsca', sortable: true, filter: true, resizable: true },

     /* T25111 | ALCANCE: comentar definiciones de cabecera de plantilla y reporte. Omite campos CANAL, SUBCANAL Y GRUPO CLIENTES
      NO BORRAR, SE ESPERA A FUTURO ACTIVAR
      
      { field: 'idCanal',         sortable: true, filter: true, resizable: true },
      { field: 'canalVendedorDsca', sortable: true, filter: true, resizable: true },
      { field: 'idSubCanal',      sortable: true, filter: true, resizable: true },
      { field: 'subCanalDsca',    sortable: true, filter: true, resizable: true },      
      { field: 'idGrupoCliente',   sortable: true, filter: true, resizable: true },
      { field: 'grupoClienteDsca', sortable: true, filter: true, resizable: true },
      */

      { field: 'material',        sortable: true, filter: true, resizable: true },
      { field: 'materialDsca',    sortable: true, filter: true, resizable: true },
      { field: 'macroCategoria',  sortable: true, filter: true, resizable: true },
      { field: 'categoria',       sortable: true, filter: true, resizable: true },
      { field: 'subCategoria',    sortable: true, filter: true, resizable: true },
      { field: 'marca',           sortable: true, filter: true, resizable: true },
      { field: 'enero',           sortable: true, filter: true, resizable: true },
      { field: 'febrero',         sortable: true, filter: true, resizable: true },
      { field: 'marzo',           sortable: true, filter: true, resizable: true },
      { field: 'abril',           sortable: true, filter: true, resizable: true },
      { field: 'mayo',            sortable: true, filter: true, resizable: true },
      { field: 'junio',           sortable: true, filter: true, resizable: true },
      { field: 'julio',           sortable: true, filter: true, resizable: true },
      { field: 'agosto',          sortable: true, filter: true, resizable: true },
      { field: 'septiembre',      sortable: true, filter: true, resizable: true },
      { field: 'octubre',         sortable: true, filter: true, resizable: true },
      { field: 'noviembre',       sortable: true, filter: true, resizable: true },
      { field: 'diciembre',       sortable: true, filter: true, resizable: true },
      { field: 'error.errorCampo', headerName: 'ERROR', sortable: true, filter: true, resizable: true, width: 600,
        cellStyle: this.changeRowColor.bind(this)      
      },
    ];
  
  }


  changeRowColor(params) {
    console.log("param", params);
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
      else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return true;
  }


  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    // formData.append('multipart', data.multipart);
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    formData.append('anio', this.formulario.get('anio').value);
    return formData;
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  enviarFormulario() {

    let request = this.setFormData(this.formulario.value);

    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: 'Presupuesto Promo',
        action: 'Enviar',
        funcion: this._indicadores.presupuestoPromoUploadCSV(request),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title   : 'Esta seguro que desea guardar el siguiente listado de Presupuesto?',
        text    : 'PROMOCIONAL',
        action  : 'Guardar',
        funcion : this._indicadores.presupuestoPromoUploadSave(this.rowData),
        loading : true,
        context : this,
      }
    ).then((res: any) => {
      this._util.mensajeOKVisto(res, true, 10000);
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  downloadCsvFormato() {
    let   namePlantilla: string = "plantilla-Presupuesto-Promocional.csv";
    let   cabecera: any[] = this.catalogoPresupuesto.csvCabeceraPresuPromocional();
    const dataText: any[] = this.catalogoPresupuesto.csvPruebaPresuPromocional();
    
    this._util.exportCSV(cabecera, dataText, namePlantilla);
  }

  downloadDataCsv() {
    let data: any = [];
    let name: string = "REGISTRO_ERRORES.csv";

    let cabecera: any[] = [[
      'anio', 
      'idOrganizacionVenta', 
      'organizacionVentaDsca', 
      'idCanalVenta', 
      'canalVentaDsca', 
      'idUnidadNegocio', 
      'unidadNegocioDsca', 
      /*'canal', 
      'canalDsca', 
      'idSubCanal', 
      'subCanalDsca', 
      'grupoPrecio', 
      'grupoPrecioDsca', */
      'material', 
      'dscaMaterial', 
      'macroCategoria', 
      'categoria', 
      'subcategoria', 
      'marca', 
      'presupuesto',
      'enero', 
      'febrero', 
      'marzo', 
      'abril', 
      'mayo', 
      'junio', 
      'julio', 
      'agosto', 
      'septiembre', 
      'octubre', 
      'noviembre', 
      'diciembre',
      'Estado',
      'Linea',
      'Error'
    ]];

    let clonData = this.rowData.map((x) => Object.assign({}, x));

    clonData.forEach((e) => {
      if (!e.isCorrect) {
        data.push(
          {
            anio                : e.anio, 
            idOrganizacionVenta : e.idOrganizacionVenta, 
            organizacionVentaDsca : e.organizacionVentaDsca, 
            idCanalVenta        : e.idCanalVenta, 
            canalVentaDsca      : e.canalVentaDsca, 
            idUnidadNegocio     : e.idUnidadNegocio, 
            unidadNegocioDsca   : e.unidadNegocioDsca,
            /*canal               : e.canal,
            canalDsca           : e.canalDsca,
            idSubCanal          : e.idSubCanal, 
            subCanalDsca        : e.subCanalDsca, 
            grupoPrecio         : e.grupoPrecio,
            grupoPrecioDsca     : e.grupoPrecioDsca,*/
            material            : e.material, 
            materialDsca        : e.materialDsca, 
            macroCategoria      : "'"+ e.macroCategoria, 
            categoria           : "'"+ e.categoria, 
            subcategoria        : "'"+ e.subCategoria, 
            marca               : "'"+ e.marca, 
            presupuesto         : e.presupuesto,  
            enero               : e.enero,
            febrero             : e.febrero,
            marzo               : e.marzo,
            abril               : e.abril,
            mayo                : e.mayo,
            junio               : e.junio,
            julio               : e.julio,
            agosto              : e.agosto,
            septiembre          : e.septiembre,
            octubre             : e.octubre,
            noviembre           : e.noviembre,
            diciembre           : e.diciembre,   
            estado              : (e.correct) ? 'CORRECTO' : 'INCORRECTO',
            linea               : (e.error === undefined) ? '' : e.error.linea,
            errorCampo          : (e.error === undefined) ? '' : e.error.errorCampo,
          }
        );
      }
    });

    this._util.exportCSV(cabecera, data, name);
    this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

}
